<template>
  <!--編輯-->
  <v-dialog v-model="isVisible"
            persistent
            no-click-animation
            max-width="50%">
    <v-card>
      <v-card-title>
        <h2>編輯</h2>
      </v-card-title>
      <v-card-text>
        <v-tabs fixed-tabs v-model="tab">
          <v-tab key="0">
            申辦資料
          </v-tab>
          <v-tab key="1">
            附件
          </v-tab>
        </v-tabs>
        <v-tabs-items v-model="tab">
          <v-tab-item key="0">
            <div class="mt-2">
              <v-layout xs12 >
                <v-flex>
                  <v-text-field
                    v-model="user.name"
                    :label="`姓名`"
                    background-color='#49bcfd'
                    outline></v-text-field>
                </v-flex>
                <v-flex>
                  <v-text-field
                    v-model="user.cellphone"
                    :label="`電話`"
                    background-color='#49bcfd'
                    outline></v-text-field>
                </v-flex>
              </v-layout>
              <v-layout xs12 >
                <v-flex>
                  <v-text-field
                    v-model="user.memberId"
                    :label="`身分證`"
                    background-color='#49bcfd'
                    outline></v-text-field>
                </v-flex>
                <v-flex>
                  <v-text-field
                    v-model="user.line"
                    :label="`LINE ID`"
                    background-color='#49bcfd'
                    outline></v-text-field>
                </v-flex>
              </v-layout>
              <v-layout xs12 class="p-2">
                <v-flex>
                  <v-text-field
                    v-model="user.residencePost"
                    :label="`郵遞區號`"
                    background-color='#49bcfd'
                    disabled
                    outline></v-text-field>
                </v-flex>
                <v-flex>
                  <v-select v-model="user.residenceCity" :label="`戶籍縣市`" :items="cityList">
                  </v-select>
                </v-flex>
                <v-flex>
                  <v-select v-model="user.residenceArea" :label="`戶籍區域`" :items="areaList[user.residenceCity]">
                  </v-select>
                </v-flex>
              </v-layout>
              <v-layout xs12>
                <v-flex>
                  <v-text-field
                    v-model="user.residenceAddress"
                    :label="`戶籍地址`"
                    background-color='#49bcfd'
                    outline></v-text-field>
                </v-flex>
              </v-layout>

              <v-layout>
                <v-flex>
                  <v-checkbox
                    v-model="copyResidenceAddress"
                    label="同戶籍"
                  ></v-checkbox>
                </v-flex>
              </v-layout>

              <v-layout xs12 class="p-2">
                <v-flex>
                  <v-text-field
                    v-model="user.homePost"
                    :label="`郵遞區號`"
                    background-color='#49bcfd'
                    disabled
                    outline></v-text-field>
                </v-flex>
                <v-flex>
                  <v-select v-model="user.homeCity" :label="`通訊縣市`" :items="cityList">
                  </v-select>
                </v-flex>
                <v-flex>
                  <v-select v-model="user.homeArea" :label="`通訊區域`" :items="areaList[user.homeCity]">
                  </v-select>
                </v-flex>
              </v-layout>
              <v-layout xs12>
                <v-flex>
                  <v-text-field
                    v-model="user.homeAddress"
                    :label="`通訊地址`"
                    background-color='#49bcfd'
                    outline></v-text-field>
                </v-flex>
              </v-layout>

              <hr>
              <v-layout xs12 class="mt-2">
                <v-flex>
                  <v-text-field
                    v-model="user.company"
                    :label="`公司名稱`"
                    background-color='#49bcfd'
                    outline></v-text-field>
                </v-flex>
                <v-flex>
                  <v-text-field
                    v-model="user.companyTitle"
                    :label="`職稱`"
                    background-color='#49bcfd'
                    outline></v-text-field>
                </v-flex>
              </v-layout>
              <v-layout xs12 >
                <v-flex>
                  <v-text-field
                    v-model="user.workYear"
                    :label="`年資(年)`"
                    background-color='#49bcfd'
                    outline></v-text-field>
                </v-flex>
                <v-flex>
                  <v-text-field
                    v-model="user.workMonth"
                    :label="`年資(月)`"
                    background-color='#49bcfd'
                    outline></v-text-field>
                </v-flex>
              </v-layout>

              <v-layout xs12 class="p-2">
                <v-flex>
                  <v-text-field
                    v-model="user.companyPost"
                    :label="`郵遞區號`"
                    background-color='#49bcfd'
                    disabled
                    outline></v-text-field>
                </v-flex>
                <v-flex>
                  <v-select v-model="user.companyCity" :label="`公司縣市`" :items="cityList">
                  </v-select>
                </v-flex>
                <v-flex>
                  <v-select v-model="user.companyArea" :label="`公司區域`" :items="areaList[user.companyCity]">
                  </v-select>
                </v-flex>
              </v-layout>
              <v-layout xs12>
                <v-flex>
                  <v-text-field
                    v-model="user.companyAddress"
                    :label="`公司地址`"
                    background-color='#49bcfd'
                    outline></v-text-field>
                </v-flex>
              </v-layout>

              <v-layout xs12 >
                <v-flex xs6 md6>
                  <v-text-field
                    v-model="user.companyPhone"
                    :label="`公司電話`"
                    background-color='#49bcfd'
                    outline></v-text-field>
                </v-flex>
                <v-flex>
                  <v-checkbox
                    v-model="user.hasInsured"
                    label="是否有投保勞健保"
                  ></v-checkbox>
                </v-flex>
              </v-layout>
              <v-layout xs12 >
                <v-flex>
                  <v-checkbox
                    v-model="user.hasCreditCard"
                    label="是否使用信用卡"
                  ></v-checkbox>
                </v-flex>
                <v-flex>
                  <v-select v-model="user.paymentStatus" :items="getPaymentStatus"
                            item-text="value"
                            item-value="key">
                  </v-select>
                </v-flex>
              </v-layout>
              <v-layout xs12 >
                <v-flex>
                  <v-checkbox
                    v-model="user.hasHouse"
                    label="名下是否有不動產"
                  ></v-checkbox>
                </v-flex>
                <v-flex>
                  <v-checkbox
                    v-model="user.hasCar"
                    label="名下是否持有機車或汽車"
                  ></v-checkbox>
                </v-flex>
              </v-layout>
              <v-layout xs12 >
                <v-flex>
                  <v-text-field
                    v-model="user.needAmount"
                    :label="`*資金需求(萬)`"
                    background-color='#49bcfd'
                    outline></v-text-field>
                </v-flex>
              </v-layout>
              <v-layout xs12 >
                <v-flex>
                  <v-checkbox
                    v-model="user.hasCredit"
                    label="近6個月是否有申請過貸款"
                  ></v-checkbox>
                </v-flex>
                <v-flex>
                  <v-checkbox
                    v-model="user.hasOtherVendorCredit"
                    label="目前有無繳款的中貸款、購物分期"
                  ></v-checkbox>
                </v-flex>
              </v-layout>
            </div>

          </v-tab-item>

          <v-tab-item key="1">
            <div class="mt-2">
              <v-layout  row wrap>
                <v-flex>
                  <div class="dropbox">
                    <input type="file" ref="file" multiple :name="uploadFieldName"
                           @change="filesChange($event.target.name, $event.target.files);"
                           accept="image/*,.pdf" class="input-file">
                    <p>
                      將圖片或PDF(一張或多張)拖到此處<br> 或點擊上傳
                    </p>
                  </div>
                </v-flex>
              </v-layout>
              <v-layout  row wrap class="p2">
                <v-flex md6 v-for="(file, i) of files" :key="i">
                  <v-card class="p2">
                    <v-card-text>
                      <v-layout>
                        <img v-if="file.url && file.url !== ''" :src="file.url" style="height: 150px;">
                        <img v-else :src="file.image" style="height: 150px;">
                      </v-layout>
                      <span>
                        {{file.name}}
                      </span>
                    </v-card-text>
                    <v-card-actions>
                      <v-btn color="red" dark text @click="removeFile(i)">刪除</v-btn>
                    </v-card-actions>
                  </v-card>
                </v-flex>
              </v-layout>
            </div>
          </v-tab-item>
        </v-tabs-items>


        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="red" dark text @click="closeEvent">取消</v-btn>
          <v-btn class="primary" dark text :loading="saveLoading" @click="confirmEvent">確定</v-btn>
        </v-card-actions>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import BankInfoModel from '../models/BankInfoModel';
import { getNow, getUUId } from '@/pages/utils/tool';
import common from '@/mixins/common';
const bankCodeList = require('../assets/bank_data.json');
export default {
  name: 'GoodDealDialog',
  props: {
    visible: Boolean,
    item: Object,
  },
  mixins:[common],
  data() {
    return {
      saveLoading: false,
      tab: 0,
      cityData: require('../assets/taiwan_city'),
      uploadedFiles: [],
      uploadFieldName: 'photos',
      cityList: [],
      areaList: {},
      loading: false,
      isVisible:false,
      officialItem:{
        bankId:'',
        bankSubId:''
      },
      user: {
        caseId: '',
        userId:'',
        name:'',
        memberId: '',
        cellphone:'',
        line:'',
        paymentStatus: 0,
        phone: '',
        company : '',
        workYear: '',
        workMonth: '',
        companyTitle:'',
        companyPhone: '',
        hasInsured: false,
        hasCreditCard: false,
        hasHouse: false,
        hasCar: false,
        needAmount: '',
        hasCredit: false,
        hasOtherVendorCredit: false,
        residencePost:'',
        residenceCity:'',
        residenceArea:'',
        residenceAddress: '',
        homePost: '',
        homeCity: '',
        homeArea: '',
        homeAddress: '',
        companyPost: '',
        companyCity: '',
        companyArea: '',
        companyAddress: '',
      },
      copyResidenceAddress: false,
      files: [],
    };
  },
  created() {
    this.cityData.taiwan.forEach((city) => {
      this.cityList.push(city.city);
      this.areaList[city.city] = city.area;
    });
  },
  watch:{
    visible(value){
      this.isVisible = value;
      console.log(`show gooddeal edit `)
      this.user = this.item;
      this.user.caseId = this.user.userId;
      if (this.user.fileList && this.user.fileList.length > 0){
        for (let file of this.user.fileList){
          file.name = '';
          file.image = null;
          this.files.push(file);
        }
      }
    },
    isVisible(value) {
      if(value) {
      } else {
        this.closeEvent()
      }
    },
    'user.residenceArea'(value){
      const tempList = this.areaList[this.user.residenceCity] ? this.areaList[this.user.residenceCity]:[]
      const areaArray = tempList.filter(m => m.text === value);
      if(areaArray.length > 0) {
        this.user.residencePost = areaArray[0].zip;
      }
    },
    'user.homeArea'(value){
      const tempList = this.areaList[this.user.homeCity] ? this.areaList[this.user.homeCity] :[]
      const areaArray = tempList.filter(m => m.text === value);
      if(areaArray.length > 0) {
        this.user.homePost = areaArray[0].zip;
      }
    },
    'user.companyArea'(value){
      const tempList = this.areaList[this.user.companyCity] ? this.areaList[this.user.companyCity] : []
      const areaArray = tempList.filter(m => m.text === value);
      if(areaArray.length > 0) {
        this.user.companyPost = areaArray[0].zip;
      }
    },
    copyResidenceAddress(value){
      if (value === true){
        this.user.homePost = this.user.residencePost;
        this.user.homeCity = this.user.residenceCity;
        this.user.homeArea = this.user.residenceArea;
        this.user.homeAddress = this.user.residenceAddress;
      } else {
        this.user.homePost = '';
        this.user.homeCity = '';
        this.user.homeArea = '';
        this.user.homeAddress = '';
      }
    }
  },
  computed:{
    ...mapGetters(['getUserInfo']),
    getPaymentStatus(){
      return [
        { key: -1 , value: '選擇繳款狀況'},
        { key: 0 , value: '全額繳清'},
        { key: 1 , value: '繳足最低'}
      ]
    },
  },
  methods: {
    ...mapActions(['uploadImageData', 'saveGoodDealInfo', 'saveGoodDealFiles']),
    filesChange(fieldName, fileList) {
      console.log(fileList.length);
      for (let image of fileList){
        const reader = new FileReader();
        reader.onload = (e) => {
          this.files.push({ name:image.name,
            userId: this.user.userId,
            image: e.target.result });
        }
        reader.readAsDataURL(image);
      }
      console.log(this.files);
    },
    removeFile(i){
      this.files.splice(i, 1);
    },
    async uploadFiles(){
      let list = [];
      for (let file of this.files){
        const url = await this.uploadImageData(file);
        list.push({
          fileId: getUUId(),
          userId: this.user.userId,
          url: url,
          createdDate: getNow(),
        })
      }
      try {
        if (list.length === 0) return;
        const res = await this.saveGoodDealFiles({
          userId: this.user.userId,
          items: list,
        });
        const result = res.data;
        if (result.statusCode === 0){
          this.showMessageDialog(result.message);
        }
      } catch (e) {
        console.log(e);
        this.showMessageDialog(`錯誤`);
      } finally {
        this.saveLoading = false;
      }
    },
    async save(){
      try {
        this.saveLoading = true;
        const res = await this.saveGoodDealInfo(this.user);
        this.uploadFiles();
        const result = res.data;
        if (result.statusCode === 0){
          this.showMessageDialog(result.message);
        }
      } catch (e) {
        console.log(e);
        this.showMessageDialog(`錯誤`);
      } finally {
        this.saveLoading = false;
      }
    },
    confirmEvent(){
      this.save();
      this.$emit('confirmEvent', this.editedItem);
    },
    closeEvent() {
      this.$emit('closeEvent');
    }
  }
};
</script>

<style scoped>
.imgBox {
  box-shadow: 4px 4px 12px -2px rgba(20%,20%,40%,0.5);

}

.image-view {
  width: 100%;
  height: 180px;
  object-fit: scale-down;
}

.image-title {

  white-space: nowrap;
  text-overflow: ellipsis;
  width: 100%;
  display: block;
  overflow: hidden
}


.dropbox {
  outline: 2px dashed grey; /* the dash box */
  outline-offset: -10px;
  background: white;
  color: dimgray;
  padding: 10px 10px;
  min-height: 200px; /* minimum height */
  position: relative;
  cursor: pointer;
}

.input-file {
  opacity: 0; /* invisible but it's there! */
  width: 100%;
  height: 200px;
  position: absolute;
  cursor: pointer;
}

.dropbox:hover {
  background: white;
}

.dropbox p {
  font-size: 1.2em;
  text-align: center;
  padding: 50px 0;
}
</style>



// WEBPACK FOOTER //
// src/components/GoodDealDialog.vue